import type { FC } from 'react';
import React, { memo } from 'react';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';
import { getCaption } from '@alfa-bank/site-form-helpers/meta/get-caption';
import { isError } from '@alfa-bank/site-form-helpers/meta/is-error';
import { isSuccess } from '@alfa-bank/site-form-helpers/meta/is-success';

import { AddressInputDesktop } from '../components/address-input/address-input-desktop';
import type { IAddressFieldProps } from '../models';
import { createAddressFieldValidator } from '../helpers';

export const AddressFieldDesktop: FC<IAddressFieldProps> = memo(
    ({
        caption,
        className,
        dadataDelay,
        errorText,
        isRequired = false,
        name,
        onSelect,
        placeholder,
        progressBarValue,
    }) => {
        return (
            <Field<string>
                data={{ caption, placeholder, progressBarValue }}
                dispatchesFocus
                isRequired={isRequired}
                name={name}
                receivesFocus
                render={({ input, meta }) => {
                    return (
                        <AddressInputDesktop
                            caption={getCaption(meta, caption)}
                            className={className}
                            dadataDelay={dadataDelay}
                            error={isError(meta)}
                            forwardedRef={actions.getRef(meta)}
                            name={name}
                            onBlur={actions.onBlur(input)}
                            onCancel={actions.onCancel({
                                input,
                                meta,
                            })}
                            onChange={actions.onChange(input)}
                            onFocus={actions.onFocus(input)}
                            onSelect={val => {
                                actions.onSelect({ input, meta })(val);
                                onSelect();
                            }}
                            placeholder={placeholder}
                            success={isSuccess(meta)}
                            value={input.value}
                        />
                    );
                }}
                validate={createAddressFieldValidator(name, errorText)}
            />
        );
    }
);
